import React from 'react'
import { Message } from 'semantic-ui-react'
import { connect } from 'react-redux'

const ConnectedStatus = ({ isConnected }) => (
    isConnected ? null : (<Message negative floating>
        <Message.Header>Sei disconnesso</Message.Header>
        <p>Se non ti riconnetti automaticamente entro qualche secondo <a href={window.location.href}>ricarica la pagina</a>.</p>
    </Message>)
)


const mapStateToProps = (state) => ({
    isConnected: state.connected
})

export default connect(
    mapStateToProps
)(ConnectedStatus)


// WEBPACK FOOTER //
// ./src/components/ConnectedStatus.js